import Ajax from '@/lib/ajax'

export default {
  /**
   * 获取会员列表
   */
  getVipList(
    pageSize: number,
    currentPage: number,
    filter?: string,
    Tags?: string[],
    Levels?: string[],
    BeginTime?: Date,
    EndTime?: Date
  ) {
    let params = {
      filter: filter,
      MaxResultCount: pageSize,
      Tags: Tags,
      Levels: Levels,
      BeginTime: BeginTime,
      EndTime: EndTime,
      SkipCount: currentPage <= 1 ? 0 : (currentPage - 1) * pageSize
    }
    return Ajax.get(`/api/Vip/VipInfos/GetListPaged`, {
      params: params
    })
  },
  /**
   * 获取新会员列表
   */
  getNewVipList(
    pageSize: number,
    currentPage: number,
    filter?: string,
    storeId?: string,
  ) {
    let params = {
      MaxResultCount: pageSize,
      SkipCount: currentPage <= 1 ? 0 : (currentPage - 1) * pageSize
    }
    if(filter) {
      params['filter'] = filter
    }
    if(storeId) {
      params['storeId'] = storeId
    }
    return Ajax.get(`/api/Vip/VipInfos/GetListPaged`, {
      params: params
    })
  },

  /**
   * 获取会员等级列表
   */
  getVipLevels() {
    return Ajax.get('/api/Vip/VipInfos/GetVipLevels')
  },

  /**
   * 积分清零
   */
  clearBonus(userIds: string[]) {
    return Ajax.post('/api/Vip/VipCard/ClearBonus', userIds)
  },

  /**
   * 获取指定会员信息
   * @param id
   */
  getVipInfos(id: string) {
    return Ajax.get(`/api/Vip/VipInfos?id=${id}`)
  },

  /**
   * 获取会员积分记录
   * @param MaxResultCount
   * @param SkipCount
   * @param Filter
   * @param Begin
   * @param End
   */
  getBonusLog(
    UserId: string,
    MaxResultCount: number,
    currentPage: number,
    Filter?: string,
    Begin?: string,
    End?: string
  ) {
    return Ajax.get(`/api/Vip/VipInfos/BonusLogs`, {
      params: {
        UserId: UserId,
        MaxResultCount: MaxResultCount,
        SkipCount: currentPage <= 1 ? 0 : (currentPage - 1) * MaxResultCount,
        Filter: Filter,
        Begin: Begin,
        End: End
      }
    })
  },

  /**
   * 获取会员储值记录
   * @param MaxResultCount
   * @param SkipCount
   * @param Filter
   * @param Begin
   * @param End
   */
  getBalanceLogs(
    UserId: string,
    MaxResultCount: number,
    currentPage: number,
    Filter?: string,
    Begin?: string,
    End?: string
  ) {
    return Ajax.get(`/api/Vip/VipInfos/BalanceLogs`, {
      params: {
        UserId: UserId,
        MaxResultCount: MaxResultCount,
        SkipCount: currentPage <= 1 ? 0 : (currentPage - 1) * MaxResultCount,
        Filter: Filter,
        Begin: Begin,
        End: End
      }
    })
  },

  /**
   * 获取指定会员的收藏
   * @param UserId
   * @param MaxResultCount
   * @param SkipCount
   * @param Sorting
   */
  getVipFavorite(
    UserId: string,
    MaxResultCount: number,
    currentPage: number,
    Sorting?: string
  ) {
    return Ajax.get(`/api/Vip/Public/VipFavorite`, {
      params: {
        UserId: UserId,
        MaxResultCount: MaxResultCount,
        SkipCount: currentPage <= 1 ? 0 : (currentPage - 1) * MaxResultCount,
        Sorting: Sorting
      }
    })
  },

  /**
   * 获取会员浏览记录
   * @param UserId
   * @param MaxResultCount
   * @param SkipCount
   * @param Type
   * @param Filter
   * @param Begin
   * @param End
   */
  getVipRecentLogs(
    UserId: string,
    MaxResultCount: number,
    currentPage: number,
    Type: string,
    Filter?: string,
    Begin?: string,
    End?: string
  ) {
    return Ajax.get(`/api/Vip/VipRecentLogs`, {
      params: {
        UserId: UserId,
        MaxResultCount: MaxResultCount,
        SkipCount: currentPage <= 1 ? 0 : (currentPage - 1) * MaxResultCount,
        Type: Type,
        Filter: Filter,
        Begin: Begin,
        End: End
      }
    })
  },
  /**
   * 更新会员备注信息
   * @param id 
   * @param remark 
   */
  updateRemark(id: string, remark: string) {
    return Ajax.put(`/api/Vip/VipInfos/remark?id=${id}&remark=${remark}`)
  }
}
